import groupBy from "lodash/groupBy";
import { DetailedUserWithStats } from "@/user/user.d";
import { REFERRAL_COLUMN_TO_STATUS } from "./constants";
import { IReferral, IReferralApiResponse, ReferralColumn } from "./referral";

export const getEnrichedReferral = (
  referral: IReferralApiResponse,
): IReferral => ({
  ...referral,
  advocate: {
    ...referral.advocate,
    signup_source: referral.signup_source,
    business: referral.business,
  },
});

export const groupReferralsByColumnStatuses = (referrals: IReferral[]) => {
  // First group referrals by their status
  const groupedReferrals = groupBy(referrals, (referral) => referral.status);

  // Create an object with each column containing its relevant referrals
  return Object.entries(REFERRAL_COLUMN_TO_STATUS).reduce(
    (acc, [column, status]) => {
      acc[column as ReferralColumn] = groupedReferrals[status] || [];
      return acc;
    },
    {} as Record<ReferralColumn, IReferral[]>,
  );
};

const signupCount = (user: DetailedUserWithStats) =>
  user.stats?.signup_count ?? 0;

export const getSignupRank = (
  users: DetailedUserWithStats[],
  user: DetailedUserWithStats,
) => {
  const count = signupCount(user);
  if (count === 0) return null;
  return users.filter((other) => signupCount(other) > count).length + 1;
};
